/**
 * Shared controls for taking something out of a list.
 *
 * Archive is offered first and delete second, which is the opposite of most
 * lists. That ordering reflects the schema rather than taste: `sends` and
 * `events` cascade from `campaigns`, so deleting anything that has sent takes
 * its delivery history and reports with it. The API refuses that, and these
 * buttons are arranged so the refusal is rarely reached in the first place.
 */

export function ShowArchived({
  value,
  onChange,
  count,
}: {
  value: boolean;
  onChange: (next: boolean) => void;
  count?: number;
}) {
  return (
    <button type="button" className="btn ghost" onClick={() => onChange(!value)}>
      {value ? "Hide archived" : "Show archived"}
      {!value && count ? ` (${count})` : ""}
    </button>
  );
}

export function RetireActions({
  archived,
  pending,
  onArchive,
  onUnarchive,
  onDelete,
  deleteLabel = "Delete",
}: {
  archived: boolean;
  pending: boolean;
  onArchive: () => void;
  onUnarchive: () => void;
  /** Omitted where deleting is never on offer. */
  onDelete?: (() => void) | undefined;
  deleteLabel?: string;
}) {
  if (archived) {
    return (
      <button type="button" className="btn ghost small" disabled={pending} onClick={onUnarchive}>
        Unarchive
      </button>
    );
  }

  return (
    <>
      <button type="button" className="btn ghost small" disabled={pending} onClick={onArchive}>
        Archive
      </button>{" "}
      {onDelete && (
        <button type="button" className="btn ghost small" disabled={pending} onClick={onDelete}>
          {deleteLabel}
        </button>
      )}
    </>
  );
}
